module.exports = __webpack_public_path__ + "static/screenshot_reports-14d0b04236d5a7ac9692120f25eed775.png";